import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles';
import DashboardLayout from '../DashboardLayout';

import BackgroundImage from '../../images/background/background-home.jpg';
import ProductDescription from '../products/ProductDescription';
import UserInvitations from '../../containers/UserInvitations';
import AlertBanner from '../../containers/AlertBanner';


/** 
 * Account page component.
 * Displays a list of all products with corresponding subscriptions, 
 * licences and invitations
*/

const styles = theme => ({
  root: {
    backgroundImage:`url(${BackgroundImage})`, 
    backgroundSize: 'cover', 
    height: '100vh',
    flex: 1,
    overflow: 'auto',
  },
  title: {
    display:'flex', 
    justifyContent:'center', 
    marginBottom:32,
    marginTop:120
  },
  defaultText: {
    color: '#797979',
    fontWeight: 300
  },
  content: {
    display:'flex', 
    flexDirection:'row', 
    justifyContent:'space-evenly',
    flexWrap: 'wrap'
  },
  product: {
    maxWidth: 296,
    margin: 16,
  }
});

class HomePage extends Component {

  render() {
    const {
      user,
      products,
      account,
      classes
    } = this.props;

    const subscriptionsByProductIds = (account 
        && account.subscriptions 
        && account.subscriptions.reduce( (memo, subscription) => {
          memo[subscription.plan.product.id] = subscription;
          return memo;
        }, {})
      )
      || {};

    return (
      <div className={classes.root} >
        <DashboardLayout 
          visible={false}
          banner={
            <Fragment>
              {
                user.alerts 
                && user.alerts.map(alert => <AlertBanner key={alert.id} alert={alert} user={user} />)
              }
              <UserInvitations />
            </Fragment>
          }
        >
            <div className={classes.title} >
              <Typography className={classes.defaultText} variant="h4" >Our Products</Typography>
            </div>
            <div className={classes.content} >
              {products.map(product => (
              <div key={product.id} className={classes.product} >
                <ProductDescription 
                  product={product} 
                  subscription={subscriptionsByProductIds[product.id]}
                />
              </div>
            ))}
            </div>
        </DashboardLayout>
      </div>
    )
  }
}

HomePage.propTypes = {
  user: PropTypes.object.isRequired,
  products: PropTypes.array.isRequired,
  account: PropTypes.object
}

export default withStyles(styles)(HomePage);


// WEBPACK FOOTER //
// ./src/components/accounts/HomePage.js